/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type CartNav_financialAmount = {
    readonly amount: number | null;
    readonly currency: Currency | null;
    readonly convertedAmountList: ReadonlyArray<{
        readonly currency: Currency | null;
        readonly amount: number | null;
    } | null> | null;
    readonly " $refType": "CartNav_financialAmount";
};
export type CartNav_financialAmount$data = CartNav_financialAmount;
export type CartNav_financialAmount$key = {
    readonly " $data"?: CartNav_financialAmount$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CartNav_financialAmount">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "CartNav_financialAmount",
        "selections": [
            (v0 /*: any*/),
            (v1 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "kind": "LinkedField",
                "name": "convertedAmountList",
                "plural": true,
                "selections": [
                    (v1 /*: any*/),
                    (v0 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "type": "FinancialAmount",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '0acaf8d56c1e760cd755053b99d56c54';
export default node;
